<template>
  <a :href="link" class="grid-promo-tile">
    <div class="grid-promo-tile__frame">
      <Media
        cover
        cover-position="top center"
        :images="activeImages"
        class="grid-promo-tile__media"
      />
      <div class="grid-promo-tile__content">
        <h2 class="grid-promo-tile__title">
          <span v-for="(line, index) in titleLines" :key="index">{{
            line
          }}</span>
        </h2>
        <span class="grid-promo-tile__cta">{{ buttonText }}</span>
      </div>
    </div>
  </a>
</template>

<script>
import Media from "@/components/Media.vue";

export default {
  name: "GridPromoTile",
  components: {
    Media,
  },
  inject: ["mq"],
  props: {
    titleLines: {
      type: Array,
      default: () => [],
    },
    buttonText: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
    images: {
      type: Object,
      required: true,
    },
    desktopImages: {
      type: Object,
      default: null,
    },
  },
  computed: {
    activeImages() {
      if (this.desktopImages && this.mq?.lgPlus) {
        return this.desktopImages;
      }

      return this.images;
    },
  },
};
</script>

<style lang="scss" scoped>
.grid-promo-tile {
  display: block;
  width: 100%;
  color: $color-white;
  text-decoration: none;
  cursor: pointer;

  &__frame {
    position: relative;
    overflow: hidden;
    width: 100%;
  }

  &__media {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;

    :deep(.wrapper),
    :deep(.media) {
      height: 100%;
    }
  }

  &__content {
    position: absolute;
    inset: 0;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    text-align: center;
    padding: 24px 24px 32px;
  }

  &__title {
    @include editorial-headline(22px);
    text-transform: uppercase;
    margin: 0;
    line-height: 1.05;
    display: flex;
    flex-direction: column;
    gap: 0;

    @include respond-above(md) {
      @include editorial-headline(28px);
    }
  }

  &__cta {
    @include utility-button(11px);
    text-transform: uppercase;
    letter-spacing: 0.08em;
    border-bottom: 1px solid currentColor;
    padding-bottom: 4px;
    line-height: 1;
  }
}
</style>
